import React from "react";
import styles from "./ButtonGroup.less";
import cx from "classnames";
export function ButtonGroup(props) {
  var opts = {
    className: cx(styles.ButtonGroup, props.className)
  };
  return React.createElement("div", opts, React.Children.map(props.children, function (child) {
    if (child) {
      return React.cloneElement(child, {
        className: cx(styles.child, child.props.className)
      });
    }
  }));
}